module.exports = __webpack_public_path__ + "img/recommend_result.9eac7e2d.png";